export default {
  contractModels: [],
  contractModel: {},
  contractsGrid: {
    data: [],
    total: 0
  }
}
